import React, { useState, useEffect, useRef } from "react";
import HeadingArea from '../../general/HeadingArea';
import ResponseMsg2 from "../../general/ResponseMsg2";
import { AiOutlineSearch } from 'react-icons/ai';
import { FaPrint } from "react-icons/fa";


const LessPlanoverview = ({setLoading}) => {
    const [response2, setResponse2] = useState({ message: '', status: 'success' });

  const [classes, setClasses] = useState([]);
  const [selectedClassId, setSelectedClassId] = useState('');
  const [subjects, setSubjects] = useState([]);
const [lessons, setLessons] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState('');
const [myTopic, setMyTopic] = useState([]);
const printRef = useRef(null);

  // Fetch Classes
  const fetchClasses = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-classes');
      if (response.ok) {
        const data = await response.json();
        setClasses(data);
      } else {
        console.error('Failed to fetch class');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch Assigned Subjects
  const fetchAssignSubject = async (classId) => {
    if (!classId) return;
    setLoading(true);
    try {
      const res = await fetch(`https://api.kcian.in/fetch-assigned-subject?class_id=${classId}`);
      if (res.ok) {
        const data = await res.json();
        if (data.length > 0) {
          const uniqueSubjectsMap = new Map();
          data.forEach(item => {
            if (!uniqueSubjectsMap.has(item.sub_id)) {
              uniqueSubjectsMap.set(item.sub_id, item);
            }
          });
          const uniqueSubjects = Array.from(uniqueSubjectsMap.values());
          setSubjects(uniqueSubjects);
          setResponse2({ message: 'Subjects Loaded.', status: 'success' });
        } else {
          setSubjects([]);
          setResponse2({ message: 'No subjects assigned to this class.', status: 'error' });
        }
      } else {
        setSubjects([]);
        setResponse2({ message: 'Error fetching subjects.', status: 'error' });
      }
    } catch (error) {
      console.error('Error fetching assigned subjects:', error);
    } finally {
      setLoading(false);
      setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
    }
  };


  // Effects
  useEffect(() => {
    fetchClasses();
  }, []);

  useEffect(() => {
    if (selectedClassId) {
      fetchAssignSubject(selectedClassId);
    } else {
      setSubjects([]);
    }
  }, [selectedClassId]);


const fetchLesson = async () => {
  if (!selectedClassId || !selectedSubject) {
    setResponse2({ message: 'Please select Class and Subject before fetching lessons.', status: 'error' });
    return;
  }

  try {
    setLoading(true);
    const res = await fetch(`https://api.kcian.in/fetch-lesson-plan?class_id=${selectedClassId}&sub_id=${selectedSubject}`);
    const lessonData = await res.json();

    if (res.ok) {
      if (lessonData.length > 0) {
        setLessons(lessonData);

        // Fetch topics for all lessons
        const topicResults = await Promise.all(
          lessonData.map(async (lesson) => {
            const topicRes = await fetch(`https://api.kcian.in/fetch-lesson-topic?plan_id=${lesson.id}`);
            const topicData = await topicRes.json();

            return topicData;
          })
        );

        const allTopics = topicResults.flat();
        console.log(topicResults);
        setMyTopic(allTopics);

        setResponse2({ message: 'Lessons and Topics Fetched Successfully', status: 'success' });
      } else {
        setLessons([]);
        setMyTopic([]);
        setResponse2({ message: 'No Lessons Found for this Class & Subject.', status: 'error' });
      }
    } else {
      setResponse2({ message: 'Something went wrong. Try again.', status: 'error' });
    }
  } catch (error) {
    console.error('Fetch lesson error:', error);
    setResponse2({ message: 'Error fetching lessons or topics.', status: 'error' });
  } finally {
    setLoading(false);
    setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
  }
};

  const handlePrint = () => {
    if (!myTopic.length) {
      setResponse2({ message: 'No Data available to Print', status: 'success' });
    setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
      return;
    }
    window.print();
  };

  const selectedClassName =
  classes.find(c => String(c.id) === String(selectedClassId))?.class_name || '';

const selectedSubjectName =
  subjects.find(s => String(s.sub_id) === String(selectedSubject))?.sub_name || '';

    return (
      <>
    <section className="py-4">
      <div className="px-4">
            <HeadingArea message1="Lesson Plan" message2="Plan Overview" />

                   {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}


<form
  className='profile-card'
  onSubmit={(e) => {
    e.preventDefault();
    fetchLesson();
  }}
>
            <span className="profile-heading">Select Criteria</span>

            <div className='d-md-flex d-sm-flex d-block mt-3'>
              <div className="mb-4 w-100 me-3">
                <div className='profile-input-area'>
                  <label className='profile-badge'>Class</label>
                  <select
                    className='profile-input'
                    value={selectedClassId}
                    onChange={(e) => setSelectedClassId(e.target.value)}
required
>
                    <option value=''>-- Select Class --</option>
                    {classes.map(cls => (
                      <option key={cls.id} value={cls.id}>
                        {cls.class_name}
                      </option>
                    ))}
                  </select>
                </div>
</div>

              <div className="mb-4 w-100 me-3">
                <div className='profile-input-area'>
                  <label className='profile-badge'>Subject</label>
                  <select
                    className='profile-input'
                    value={selectedSubject}
                    onChange={(e) => setSelectedSubject(e.target.value)}
                    disabled={subjects.length === 0}
                    required
                  >
                    <option value=''>-- Select Subject --</option>
                    {subjects.map(sub => (
                      <option key={sub.id} value={sub.sub_id}>
                        {sub.sub_name} ({sub.sub_type}) ({sub.sub_code})
                      </option>
                    ))}
                  </select>
                </div>
                </div>

</div>

            <div className='text-end'>
              <button type='submit' className='profile-btn2'>
                <AiOutlineSearch /> Search
              </button>
            </div>
          </form>

            {/* Table-section */}
            {/* <div className="card shadow-sm mt-5"> */}
            <div className='col-xl-9 col-lg-8 col-md-7 col-12 my-2 h-100 w-100 mt-5'>
                <div className='profile-card'>
                <div className="printable-area" ref={printRef}>

                  <span className="profile-heading">
  {selectedClassName}
  {selectedSubjectName ? ` - ${selectedSubjectName}` : ''} Subject Wise Plan
</span>

                                            <div className='d-md-flex justify-content-between mb-2 d-print-none'>


                        <div className='profile-input-area col-lg-3 border-0'>
                            <input
                                type='text'
                                name='search'
                                className='profile-input border-bottom rounded-0'
                                placeholder='Search...'
                            />
                        </div>
              <button
                className="profile-btn2 my-2"
                onClick={handlePrint}
                disabled={!myTopic.length}
              >
                <FaPrint /> Print
              </button>
                    </div>
                    

                    <div className="table-responsive mt-2">


                        <table className="table w-100">
                            <thead className="account-thead rounded-4">
                               <th className="border">S No</th>
                                    <th className="border">Lesson</th>
                                    <th className="border">Topics Covered</th>
                                    <th className="border d-print-none">Added By</th>                                
                            </thead>

<tbody>
  {myTopic.length > 0 ? (
    Object.values(
      myTopic.flat().reduce((acc, curr) => {
        const key = curr.lesson_name;
        if (!acc[key]) {
          acc[key] = {
            lesson_name: curr.lesson_name,
            addedby_name: curr.addedby_name,
            designation: curr.designation,
            topics: [],
          };
        }
        acc[key].topics.push(curr.topic_name);
        return acc;
      }, {})
    ).map((group, idx) => (
      <tr className="account-tr" key={idx}>
        <td className="border">{idx + 1}</td>
        <td className="border">{group.lesson_name}</td>
        <td className="border">
          {group.topics.map((topic, i) => (
            <div key={i}>• {topic}</div>
          ))}
        </td>
        <td className="border d-print-none">{group.addedby_name} ({group.designation})</td>
      </tr>
    ))
  ) : (
    <tr className="account-tr text-center">
      <td colSpan="4">No data available.</td>
    </tr>
  )}
</tbody>


                        </table>
                    </div>

</div>
                </div>
            </div>

        </div>
        </section>

      <style>{`
@media print {
// @page {
//   size: landscape;
// }

  body * {
    visibility: hidden;
  }
  .printable-area, .printable-area * {
    visibility: visible;
  }
  .printable-area {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    font-size: 0.8em;
  }

  .d-print-none {
    display: none !important;
  }
  .printable-area .row {
    display: flex !important;
    flex-wrap: wrap !important;
  }

}

      `}</style>

</>

    )
}

export default LessPlanoverview